import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: 100%;
  padding: 3rem 1.5rem;
  background: var(--white);
  border-radius: 0.5rem;
  text-align: center;

  p {
    font-size: var(--font-17);
    line-height: 1.5rem;
    color: var(--cinza-80);
  }

  button {
    border: 0;
    border-radius: 0.5rem;
    padding: 0.625rem 1.5rem;
    background: var(--principal-40);
    color: var(--cinza-100);
    font-size: 1rem;
    font-weight: 700;
  }
`;
